import { firePixelEvent } from "src/utils/pixels/handler";
import { ActionHandler } from "..";
import { onStartSurvey } from "./onStartSurvey";

export const onStartMainSurvey: ActionHandler = (actionConfig) => {
  onStartSurvey(actionConfig);

  firePixelEvent("startMainSurvey", {});
};
